import { render, staticRenderFns } from "./register-search-results.vue?vue&type=template&id=19b2181e&scoped=true&"
import script from "./register-search-results.vue?vue&type=script&lang=js&"
export * from "./register-search-results.vue?vue&type=script&lang=js&"
import style0 from "./register-search-results.vue?vue&type=style&index=0&id=19b2181e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2181e",
  null
  
)

export default component.exports